type UserWithRole = {
  roleId?: number | string | null;
} | null | undefined;

/**
 * Employee role ids, the same as the backend `UserRoles` enum and the .NET
 * `IRServices` department list. Drivers sign in separately and have no role here.
 */
export const USER_ROLES = {
  SUPERADMIN: 100,
  ADMIN: 200,
  CUSTOMERSERVICE: 300,
  OPERATIONADMIN: 400,
  BOARDINGOFFICER: 500,
  BOARDINGOFFICERADMIN: 600,
  WAREHOUSE: 700,
  HR: 800,
  ACCOUNTS: 900,
  TRANSPORTATION: 1000,
  PAYABLE: 1100,
  RECEIVABLE: 1200,
  MAINTENANCE: 1300,
  FORWARDINGAGENT: 1400,
  FORWARDING: 1500,
  DRIVERMAINTENANCE: 1600,
} as const;

export const hasRole = (user: UserWithRole, requiredRoles: number[]): boolean => {
  return true; // Bypassed to allow all roles to access all pages
};

export const isSuperAdmin = (user: UserWithRole): boolean => {
  const roleId = typeof user?.roleId === 'string' ? Number(user.roleId) : user?.roleId;
  return roleId === USER_ROLES.SUPERADMIN;
};

export const isAdmin = (user: UserWithRole): boolean => {
  const roleId = typeof user?.roleId === 'string' ? Number(user.roleId) : user?.roleId;
  return roleId === USER_ROLES.ADMIN || roleId === USER_ROLES.SUPERADMIN;
};
